import { Record } from 'immutable';
import { IEntitySwitcherItem } from '@opengov/components-navigation';
import { IEntity } from '@opengov/api-deprecated';

export const ENTITY_SEARCH_FIELDS: (keyof IEntity)[] = [
  'id',
  'name',
  'state',
  'country',
  'subdomain',
  'display_name',
  'entity_type'
];

export const Entity = Record<IEntity>({
  id: null,
  name: null,
  display_name: null,
  country: null,
  state: null,
  address: null,
  entity_type: null,
  subdomain: null,
  homepage_url: null,
  logo: null,
  entity_id: null,
  default_coa_id: null,
  color: {
    color: null,
    index: null
  },
  fiscal_year_start_month: null,
  population: null,
  fiscal_year_start_date_formatted: null,
  default_report_id: null,
  budget_101: null,
  feature_permissions: null,
  report_preferences: {
    expenses_variance_formula: null,
    revenues_variance_formula: null
  },
  active: null,
  published: null,
  emblem: null,
  transparency_url: null,
  tos_url: null,
  accepted_budget_license_agreement: null,
  created_at: null,
  longitude: null,
  latitude: null,
  abilities: null,
  uuid: null,
  salesforce_id: null
});

export const EntitySwitcherItem = Record<IEntitySwitcherItem>({
  id: null,
  name: null,
  subdomain: null,
  state: null,
  country: null,
  entity_type: null
});
